export default __webpack_public_path__ + "static/media/serv2.820b82d0.png";